<div class="card p-4">
  <div class="row mb-3">
    <div class="col-md-4">
      <label class="form-label">Фильтр по названию продукта</label>
      <input type="text" class="form-control" [(ngModel)]="filterText" placeholder="Введите название продукта..."
        autocomplete="off" name="filterText" />
    </div>
  </div>
  <div [formGroup]="replacementForm">
    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th style="width: 40%;">Продукт</th>
            <th style="width: 55%;">Продукты замены</th>
            <th style="width: 5%;"></th>
          </tr>
        </thead>
        <tbody formArrayName="replacements">
          @for (replacement of replacements.controls; track $index; let i = $index) {
          @if (isRowVisible(i)) {
          <tr [formGroupName]="i">
            <td>
              <div class="position-relative">
                @if (!replacement.get('product')?.value) {
                <div ngbDropdown #productDropdown="ngbDropdown" class="d-block"
                  (openChange)="productDropdowns[i] = productDropdown">
                  <input type="text" class="form-control"
                    (input)="searchProducts($any($event.target).value, productDropdown)"
                    (focus)="openDropdownIfHasResults(productDropdown)" placeholder="Продукт" />
                  <div ngbDropdownMenu class="w-100" style="max-height: 300px; overflow-y: auto;">
                    @for (product of searchedProducts; track product.iikoId) {
                    <button type="button" class="dropdown-item" (click)="selectProduct(i, product)">
                      {{ product.name }}
                    </button>
                    }
                  </div>
                </div>
                } @else {

                <div class="badge bg-primary mt-2">
                  <span class=" me-2">{{ replacement.get('product')?.value?.name }}</span>
                  <i class="fa-solid fa-times cursor-pointer"
                    (click)="replacement.patchValue({ product: null }); selectedProductForSearch[i] = null"></i>
                </div>
                }
              </div>
            </td>
            <td>
              <div formArrayName="replacementProducts">
                @for (replacementProduct of getReplacementProducts(i).controls; track $index; let j = $index) {
                <div [formGroupName]="j" class="mb-2 d-flex align-items-start">
                  <div class="position-relative flex-grow-1 me-2">
                    @if (!replacementProduct.get('product')?.value) {
                    <div ngbDropdown #replacementDropdown="ngbDropdown" class="d-block"
                      (openChange)="replacementDropdowns['row_' + i + '_rep_' + j] = replacementDropdown">
                      <input type="text" class="form-control"
                        (input)="searchReplacementProducts($any($event.target).value, replacementDropdown)"
                        (focus)="openDropdownIfHasResults(replacementDropdown)" placeholder="Продукт" />
                      <div ngbDropdownMenu class="w-100" style="max-height: 300px; overflow-y: auto;">
                        @for (product of searchedProducts; track product.iikoId) {
                        <button type="button" class="dropdown-item" (click)="selectReplacementProduct(i, j, product)">
                          {{ product.name }}
                        </button>
                        }
                      </div>
                    </div>
                    } @else {
                    <div class="badge bg-primary mt-2">
                      <span class="me-2">{{ replacementProduct.get('product')?.value?.name }}</span>
                      <i class="fa-solid fa-times cursor-pointer" (click)="removeReplacementProduct(i, j)"></i>
                    </div>
                    }
                  </div>
                </div>
                }
                <div class="mb-2">
                  <button type="button" class="btn btn-sm btn-outline-primary" (click)="addReplacementProduct(i)"
                    [disabled]="!replacement.get('product')?.value">
                    <i class="fa-solid fa-plus"></i> Добавить продукт замены
                  </button>
                </div>
              </div>
            </td>
            <td class="text-center">
              @if (!isRowEmpty(i)) {
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeRow(i)" title="Удалить строку">
                <i class="fa-solid fa-trash"></i>
              </button>
              }
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>

    <!-- Form for adding new row -->
    <div class="card mt-4 p-4">
      <h5 class="mb-3">Добавить новую замену продукта</h5>
      <div [formGroup]="newRowForm" class="row g-3">
        <div class="col-md-4">
          <label class="form-label">Продукт</label>

          <div ngbDropdown #newRowProductDropdown="ngbDropdown" class="d-block"
            (openChange)="newRowProductDropdownRef = newRowProductDropdown">
            @if(!newRowForm.get('product')?.value){
            <input type="text" class="form-control"
              (input)="searchNewRowProduct($any($event.target).value, newRowProductDropdown)"
              (focus)="openNewRowDropdownIfHasResults(newRowProductDropdown)" placeholder="Поиск продукта..."
              [value]="getProductName(newRowForm.get('product')?.value)" />
            }
            <div ngbDropdownMenu class="w-auto" style="max-height: 300px; overflow-y: auto;">
              @for (product of newRowSearchedProducts; track product.iikoId) {
              <button type="button" class="dropdown-item" (click)="selectNewRowProduct(product)">
                {{ product.name }}
              </button>
              }
            </div>
          </div>
          @if (newRowForm.get('product')?.value) {
          <div class="badge bg-primary mt-2">
            <span class=" me-2">{{ newRowForm.get('product')?.value?.name }}</span>
            <i class="fa-solid fa-times cursor-pointer" (click)="newRowForm.patchValue({ product: null })"></i>
          </div>
          }
        </div>
        <div class="col-md-8">
          <label class="form-label">Продукты замены</label>
          <div formArrayName="replacementProducts">
            @for (replacementProduct of getNewRowReplacementProducts().controls; track $index; let j = $index) {
            <div [formGroupName]="j" class="mb-2 d-flex align-items-start">
              @if (!replacementProduct.get('product')?.value){
              <div ngbDropdown #newRowReplacementDropdown="ngbDropdown" class="d-block flex-grow-1 me-2"
                (openChange)="newRowReplacementDropdownRef = newRowReplacementDropdown">
                <input type="text" class="form-control w-auto"
                  (input)="searchNewRowReplacementProduct($any($event.target).value, newRowReplacementDropdown)"
                  (focus)="openNewRowDropdownIfHasResults(newRowReplacementDropdown, true)"
                  placeholder="Поиск продукта замены..."
                  [value]="getProductName(replacementProduct.get('product')?.value!)" />
                <div ngbDropdownMenu class="w-auto" style="max-height: 300px; overflow-y: auto;">
                  @for (product of newRowReplacementSearchedProducts; track product.iikoId) {
                  <button type="button" class="dropdown-item" (click)="selectNewRowReplacementProduct(j, product)">
                    {{ product.name }}
                  </button>
                  }
                </div>
              </div>
              }


              @if (replacementProduct.get('product')?.value) {
              <div class="badge bg-primary mt-2">
                <span class=" me-2">{{ replacementProduct.get('product')?.value?.name }}</span>
                <i class="fa-solid fa-times cursor-pointer" (click)="removeNewRowReplacementProduct(j)"></i>
              </div>
              }
            </div>
            }
          </div>
        </div>
        <div class="col-12">
          <button type="button" class="btn btn-primary" (click)="addNewRow()"
            [disabled]="!newRowForm.valid || getNewRowReplacementProducts().length === 1">
            <i class="fa-solid fa-plus"></i> Добавить в таблицу
          </button>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <button (click)="save()" [disabled]="!isValidTable() || !storeId" class="btn btn-primary">
          <i class="fa-solid fa-save"></i>&nbsp;Сохранить
        </button>
      </div>
    </div>
  </div>
</div>

@if (isBusy) {
<div class="overlay">
  <i class="fa-solid fa-spinner fa-spin"></i>
</div>
}